import { Element } from 'slate';
import { EditorState } from '../Editor.types';
import { AulaEntities } from '../Entities';

/**
 * Get only the entities that are used in the current editorState value.
 */
export const getActiveEntities = (editorState: EditorState): AulaEntities => {
  const {
    context: { entities },
    value,
  } = editorState;

  return Object.keys(entities).reduce(
    (reduced: AulaEntities, entityKey: string) => {
      const activeEntities = { ...reduced };

      if (
        value.find(
          (node) => Element.isElement(node) && entityKey === node.entity,
        )
      ) {
        activeEntities[entityKey] = entities[entityKey];
      }

      return activeEntities;
    },
    {} as AulaEntities,
  );
};
